// extracted by mini-css-extract-plugin
export default {"container":"style_container__KttAr","wrapper":"style_wrapper__jxseP","panel":"style_panel__VhUj2","pic":"style_pic__MO6da"};